import type { ApiEmployee } from '@/types/employee.types';
import { countryCodeFromName } from '@/config/countries';

export interface CountryVisibility {
  isAdmin?: boolean;
  isGlobalHR?: boolean;
  countryFilter?: string | null;
}

// Access follows where the employee works, with country of origin as a fallback.
export const employeeCountry = (employee: ApiEmployee) =>
  employee.location?.trim() || employee.country?.trim() || '';

export function canViewCountry(country: string | undefined, roles: CountryVisibility) {
  if (roles.isAdmin || roles.isGlobalHR) return true;
  if (!roles.countryFilter?.trim()) return false;
  return (
    countryCodeFromName(country?.trim()).toUpperCase() ===
    countryCodeFromName(roles.countryFilter.trim()).toUpperCase()
  );
}

export function visibleEmployees(employees: ApiEmployee[], roles: CountryVisibility) {
  return employees.filter(employee => canViewCountry(employeeCountry(employee), roles));
}

export const isActiveEmployee = (employee: ApiEmployee) =>
  employee.status?.trim().toLowerCase() === 'active';
export const isProbationEmployee = (employee: ApiEmployee) =>
  isActiveEmployee(employee) && !employee.confirmationDate?.trim();
